<template>
  <div class="document-detail-view">
    <el-table v-loading="isDocInfoLoading" class="my-table" :data="docInfo">
      <template slot="empty">
        <!-- 没有数据 -->
        <NoData></NoData>
      </template>
      <el-table-column property="Name" label="文档名称" width="460">
        <template #default="{ row }">
          <div class="table-item-content">
            <img :src="mapDocType(row)" alt="" class="doc_type_icon" />
            <span class="title" :title="row.Name">
              {{ row.Name }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="Size" label="文档大小">
        <template #default="{ row }">
          <div>{{ bytesToSize(row.Size) }}</div>
        </template>
      </el-table-column>
      <el-table-column property="CTime" label="上传时间">
        <template #default="{ row }">
          {{ row.CTime ? $moment(row.CTime * 1000).format('YYYY/MM/DD HH:mm:ss') : '--' }}
        </template>
      </el-table-column>
      <el-table-column property="DownloadCount" label="下载次数"></el-table-column>
      <el-table-column label="操作">
        <template #default="{ row }">
          <el-button @click="handleClickDownload(row)" type="text">下载</el-button>
          <el-button @click="handleClickDelete(row)" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="logInfo-box" v-loading="isLogLoading">
      <div>日志列表</div>
      <div class="data-filter">
        <el-form ref="form" :model="form" :inline="true">
          <el-form-item label="文章名称:">
            <el-input v-model="form.artTitle" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="文档触发时间段:">
            <el-date-picker
              v-model="form.date"
              :unlink-panels="true"
              type="daterange"
              value-format="timestamp"
              class="release-select-time"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
            />
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" :inline="true">
          <el-form-item label="触发渠道:">
            <el-select v-model="form.channel" placeholder="请选择">
              <el-option
                v-for="item in channelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="primary" @click="onSubmitOverall">筛选</el-button>
            <el-button @click="exportData">导出数据</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="tableData">
        <template slot="empty">
          <NoData></NoData>
        </template>
        <el-table-column prop="CTime" label="文档触发时间">
          <template #default="{ row }">
            {{ row.CTime ? $moment(row.CTime * 1000).format('YYYY/MM/DD HH:mm:ss') : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="LogType" label="日志类型" />
        <el-table-column prop="ArtTitle" label="相关文章">
          <template #default="{ row }">
            <el-button type="text" @click="clickToArtDetail(row.ArtId)">
              {{ row.ArtTitle }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="Channel" label="触发渠道" />
      </el-table>
      <el-pagination
        class="pagination"
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :total="total"
        :page-size="pageParams.page_size"
        :current-page="pageParams.page_index"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <el-dialog class="my-dialog" title="提示" :visible.sync="delDialogVisible">
      <span>文档删除后将不可查看或下载，确定删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="clickDelDoc">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetDocInfo, GetDocLog, DelDoc, GetLogExcel, DownloadDoc } from '@/api/releaseManagement';
import NoData from '@/components/no-data';
import { downloadFileAction, bytesToSize } from '@/utils/util';
// import { dateFormat } from '@/utils/time';
import { IMG_SRC } from '@/utils/constant';
const { docTypeImg } = IMG_SRC;
export default {
  name: 'DocDetail',
  components: {
    NoData,
  },
  data() {
    return {
      bytesToSize,
      form: {
        artTitle: '',
        date: '',
        channel: '',
      },
      channelOptions: [
        {
          label: 'H5',
          value: 'H5',
        },
        {
          label: '小程序',
          value: '小程序',
        },
        {
          label: '管理端',
          value: '管理端',
        },
      ],
      isDocInfoLoading: false,
      docInfo: [],
      delDialogVisible: false,
      isLogLoading: false,
      tableData: [],
      total: 0, // 总页数
      pageParams: {
        page_index: 1,
        page_size: this.g_pageSizeDefault,
      },
      docId: null,
    };
  },
  created() {
    this.$store.commit('user/setBreadcrumb', [
      {
        menu_name: '发布管理',
      },
      {
        menu_name: '素材库管理',
        menu_path: 'materialManagement',
      },
      {
        menu_name: '文档',
        menu_path: 'materialManagement',
        menu_params: { componentName: 'DocComp' },
      },
      {
        menu_name: '文档详情',
        menu_path: '',
      },
    ]);
    this.docId = this.$route.query.docId;
    this.pageParams.page_size = this.g_pageSizeDefault;
    this.getList();
    this.getDocInfo();
  },
  methods: {
    mapDocType(row) {
      return docTypeImg[row.Type] || docTypeImg.default;
    },
    // 获取文档详情
    async getDocInfo() {
      this.isDocInfoLoading = true;
      try {
        const res = await GetDocInfo({
          Id: this.docId,
        });
        console.log(res);
        this.docInfo = [res.Info];
        this.isDocInfoLoading = false;
      } catch (err) {
        console.log('error', err);
        this.isDocInfoLoading = false;
      }
    },
    async getList() {
      this.isLogLoading = true;
      const params = {
        Id: this.docId, // 文档Id
        ArtTitle: this.form.artTitle,
        Channel: this.form.channel,
        STime: this.form.date ? this.form.date[0] / 1000 : null,
        ETime: this.form.date ? this.form.date[1] / 1000 + 86400 : null,
        Req: {
          PageIndex: this.pageParams.page_index,
          PageSize: this.pageParams.page_size,
          OrderBy: '-CTime', // 默认按照触发时间倒序
        },
      };
      try {
        const res = await GetDocLog(params);
        this.tableData = res.Records;
        this.total = res.Total;
        this.isLogLoading = false;
      } catch (err) {
        this.tableData = [];
        this.total = 0;
        console.log('err', err);
        this.$message.error(`查询日志失败`);
        this.isLogLoading = false;
      }
    },
    // 跳转至文章详情
    clickToArtDetail(artId) {
      if (!artId) {
        return;
      }
      this.g_tourl(`/saas/articleManagement.html?componentName=articleEdit&id=${artId}`, {
        open: true,
      });
    },
    // 选择页
    handleCurrentChange(val) {
      this.pageParams.page_index = val;
      this.getList();
    },
    // 选择页容量
    handleSizeChange(size) {
      this.pageParams.page_size = size;
      this.getList();
    },
    // 筛选
    onSubmitOverall() {
      this.pageParams.page_index = 1;
      this.getList();
    },
    async clickDelDoc() {
      try {
        await DelDoc({
          Id: this.docInfo[0].Id,
          Channel: '管理端',
        });
        this.delDialogVisible = false;
        this.$message.success('操作成功');
        this.g_tourl(`/saas/materialManagement.html?componentName=DocComp`);
      } catch (err) {
        console.log('err', err);
        this.$message.error('操作失败');
      }
    },
    handleClickDelete() {
      this.delDialogVisible = true;
    },
    // 下载文档
    async handleClickDownload(row) {
      this.$message({
        message: '正在导出',
        iconClass: 'el-icon-loading',
      });
      try {
        const res = await DownloadDoc({
          Id: row.Id,
          Channel: '管理端',
        });
        const data = await downloadFileAction(res.Url, row.Name);
        if (data) {
          this.$message.success('导出成功');
        }
      } catch (err) {
        console.log(err);
        this.$message.error('导出失败');
      }
    },
    // 导出数据
    async exportData() {
      this.$message({
        message: '正在导出',
        iconClass: 'el-icon-loading',
      });
      const params = {
        Id: this.docId, // 文档Id
        ArtTitle: this.form.artTitle,
        Channel: this.form.channel,
        STime: this.form.date ? this.form.date[0] / 1000 : null,
        ETime: this.form.date ? this.form.date[1] / 1000 : null,
        Req: {
          PageIndex: this.pageParams.page_index,
          PageSize: this.pageParams.page_size,
          OrderBy: '-CTime', // 默认按照触发时间倒序
        },
      };
      try {
        const res = await GetLogExcel({
          ...params,
        });
        const data = await downloadFileAction(res.Url, res.Url);
        if (data) {
          this.$message.success('导出成功');
        }
      } catch (err) {
        console.log('error', err);
        this.$message.error('导出失败');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.document-detail-view {
  .logInfo-box {
    padding-top: 20px;
    .data-filter {
      margin-top: 16px;
    }
  }
  .doc_type_icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
  }

  .pagination {
    float: right;
    margin-top: 12px;
  }

  .my-dialog ::v-deep.el-dialog {
    .el-dialog__body {
      text-align: center;
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>
